export default __webpack_public_path__ + "static/media/close.eaa0bc6f.svg";